import { isEmbedded as isEmbeddedHost } from "@/embed/embedHost";

// Top-level route segments that are not board IDs
const NON_BOARD_ROUTES = new Set(["loading", "dashboard"]);

interface UseAppHeaderViewModelArgs {
  rawBoardId: string | undefined;
}

interface AppHeaderViewModel {
  boardId: string | undefined;
  /**
   * The app is running inside a host that brings its own chrome, so the header
   * drops the parts that would duplicate it — brand, help and language — and
   * keeps only what is specific to OneTaskList.
   */
  isEmbedded: boolean;
}

export const useAppHeaderViewModel = ({
  rawBoardId,
}: UseAppHeaderViewModelArgs): AppHeaderViewModel => {
  const boardId =
    rawBoardId && !NON_BOARD_ROUTES.has(rawBoardId) ? rawBoardId : undefined;

  return { boardId, isEmbedded: isEmbeddedHost() };
};
